// Numeric constants
export const ZERO = 0;
export const ONE = 1;
export const RADIX_DECIMAL = 10;
export const FIRST_ELEMENT_INDEX = 0;

// UI Size constants
export const DIALOG_HEIGHT_VH = '80vh';
export const TABLE_MAX_HEIGHT_PX = 500;
export const TABLE_MIN_HEIGHT_PX = 200;
export const MIN_WIDTH_SERIAL_SELECT = 120;
export const MIN_WIDTH_QUANTITY_CELL = '100px';
export const WIDTH_QUANTITY_INPUT_XS = '60px';
export const WIDTH_QUANTITY_INPUT_SM = '100px';
export const SPIN_BUTTON_HEIGHT = '20px';

// Color constants
export const COLOR_ERROR_BACKGROUND = '#ffebee';
export const COLOR_WARNING_BACKGROUND = '#fff7e6';

// Table column span
export const TABLE_COLSPAN_WITH_SERIAL = 8;
export const TABLE_COLSPAN_WITHOUT_SERIAL = 7;

// Input props
export const INPUT_TYPE_NUMBER = 'number';
export const INPUT_SIZE_SMALL = 'small';
export const VARIANT_OUTLINED = 'outlined';

// Dialog size
export const DIALOG_MAX_WIDTH = 'xl';

// Field names for product object
export const PRODUCT_FIELDS = {
    PART_DESCRIPTION: 'PARTDES',
    PART_NAME: 'PARTNAME',
    PROMO_EXAMPLE: 'NEO_EXMPLE',
    LOG_COUNTERS_SUBFORM: 'LOGCOUNTERS_SUBFORM',
    BALANCE: 'BALANCE',
    UNIT_NAME: 'UNITNAME',
    CONVERSION: 'CONV',
    PART_BALANCE_SUBFORM: 'PARTBALANCE_SUBFORM',
    SERIAL_NAME: 'SERIALNAME',
    QUANTITY: 'quantity',
    SELECTED_SERIAL: 'selectedSerial',
    IS_OVER_LIMIT: 'isOverLimit'
};

// Empty string constant
export const EMPTY_STRING = '';

// UI text constants (Hebrew)
export const UI_TEXT = {
    SELECT_BATCH: 'בחר אצווה',
    BATCH_PREFIX: 'אצווה',
    NO_VALUE_PLACEHOLDER: '-'
};
